(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.headerCoords = {};
    this.calcHeaderCoords()

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	calcHeaderCoords() {
    const clientRect = this.getBoundingClientRect();
    const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.headerCoords.bottom = pageYOffset + clientRect.bottom;
    this.headerCoords.top = pageYOffset + clientRect.top;
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					this.header.classList.add('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					this.header.classList.remove('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerCoords.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true);
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kn-work-evidence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const storageKey = 'kn-work-reference-last-v1';

    function readPool(container) {
      const node = container.querySelector('[data-kn-reference-pool]');
      return node ? JSON.parse(node.textContent) : { products: [], next: '' };
    }

    async function loadProducts(card) {
      let page = readPool(card);
      const products = new Map();
      const visited = new Set();
      while (page) {
        for (const product of page.products || []) {
          if (product.id && product.title && product.url && product.image) {
            products.set(String(product.id), product);
          }
        }
        if (!page.next) break;
        const url = new URL(page.next, window.location.href);
        if (url.origin !== window.location.origin || visited.has(url.href)) break;
        visited.add(url.href);
        url.searchParams.set('sections', card.dataset.sectionId);
        try {
          const response = await fetch(url.href, { signal: AbortSignal.timeout(5000) });
          if (!response.ok) break;
          const sections = await response.json();
          const html = sections[card.dataset.sectionId];
          if (typeof html !== 'string') break;
          const document = new DOMParser().parseFromString(html, 'text/html');
          page = readPool(document);
        } catch {
          break;
        }
      }
      return Array.from(products.values());
    }

    function previousProduct() {
      try {
        return JSON.parse(sessionStorage.getItem(storageKey) || 'null') || {};
      } catch {
        return {};
      }
    }

    function chooseProduct(products, previous) {
      let candidates = products.filter(product => String(product.id) !== String(previous.id));
      if (!candidates.length) candidates = products;
      const groups = new Map();
      for (const product of candidates) {
        const type = product.type || '';
        if (!groups.has(type)) groups.set(type, []);
        groups.get(type).push(product);
      }
      let types = Array.from(groups.keys());
      if (types.length > 1) types = types.filter(type => type !== previous.type);
      if (!types.length) return null;
      const group = groups.get(types[Math.floor(Math.random() * types.length)]);
      return group[Math.floor(Math.random() * group.length)];
    }

    function loadImage(product) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const timeout = setTimeout(() => reject(new Error('Image timeout')), 5000);
        image.onload = () => {
          clearTimeout(timeout);
          image.alt = product.title;
          image.width = image.naturalWidth;
          image.height = image.naturalHeight;
          image.loading = 'lazy';
          resolve(image);
        };
        image.onerror = () => {
          clearTimeout(timeout);
          reject(new Error('Image unavailable'));
        };
        image.src = product.image;
      });
    }

    async function initializeCard(card) {
      if (initialized.has(card)) return;
      initialized.add(card);
      try {
        const products = await loadProducts(card);
        const name = card.querySelector('.kn-work-tools__product-name');
        const preview = card.querySelector('.kn-work-tools__product');
        const link = card.querySelector('[data-kn-reference-link]');
        if (!name || !preview || !link) return;
        const previous = previousProduct();
        let remaining = products;
        for (let attempt = 0; attempt < 3 && remaining.length; attempt++) {
          const product = chooseProduct(remaining, previous);
          if (!product) return;
          let image;
          try {
            image = await loadImage(product);
          } catch {
            remaining = remaining.filter(candidate => candidate.id !== product.id);
            continue;
          }
          if (!card.isConnected) return;
          const oldImage = preview.querySelector('img');
          if (oldImage) oldImage.replaceWith(image);
          else preview.prepend(image);
          name.textContent = product.title;
          link.href = product.url;
          card.dataset.referenceReady = 'true';
          card.dataset.referenceCount = String(products.length);
          card.dataset.referenceType = product.type || '';
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({ id: product.id, type: product.type || '' }));
          } catch {}
          return;
        }
      } catch {}
    }

    function initialize(container) {
      container.querySelectorAll('[data-kn-work-reference]').forEach(initializeCard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'input',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
      );

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia
          .querySelector('template')
          ?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
